import templateUrl from "emun.customer/dealers/dealer-list.htm";
import basicController from "servicestack/basic.controller.properties";
import customerConfig from "emun.customer/customer.config";
import authConfig from "emun.auth/auth.config";
import AutoQuery from "servicestack/auto-query/auto-query";
import DealerPrompt from 'emun.customer/dealers/dealer-prompt'
import modals from 'webmodals/modals'
import ServiceBus from 'servicestack/service-bus'
export class DealerListController {
	constructor($scope) {
		const $ctrl = this;
		basicController($ctrl);
		var bus = $ctrl.bus = new ServiceBus($scope);
		$ctrl.config = customerConfig;
		$ctrl.authConfig = authConfig;
	}
	$onInit() {
		const $ctrl = this;
		$ctrl.query = new AutoQuery($ctrl.getAutoQueryOptions());
	}
	getAutoQueryOptions() {
		const $ctrl = this;
		return {
			url: "QueryDealerLocations.json",
			take: 24,
			pageSize: 24,
			orderBy: "Name",
			append: false,
			autoLoad: true,
			//disableQueryString: true,
			filters: [
				{ groupBy: "State",collapsed: true },
				{ groupBy: "Country",collapsed: true },
				{ groupBy: "SortValue",collapsed: true, title: "Rank" },
				{ groupBy: "Priority",collapsed: true }],
			hideLeftNav: true,
			sortOptions: {
				Id: "Id: Low to High",
				"-Id": "Id: High to Low",
				Name: "Name: A to Z",
				"-Name": "Name: Z to A",
				Address: "Address: A to Z",
				"-Address": "Address: Z to A",
				City: "City: A to Z",
				"-City": "City: Z to A",
				State: "State: A to Z",
				"-State": "State: Z to A",
				Zip: "Zip: 1 to 9",
				"-Zip": "Zip: 9 to 1"
			}
		};
	}
	load() {
		const $ctrl = this;
		return $ctrl.query.load.apply($ctrl.query, arguments);
	}
	create() {
		const $ctrl = this;
		DealerPrompt.open({ model: {} }).then(() => $ctrl.load());
	}
	view(dealer) {
		const $ctrl = this;
		DealerPrompt.open({ model: { dealer: dealer } }).then(() => $ctrl.load());
	}
	delete(dealer) {
		const $ctrl = this;
		return modals.confirm("Are you sure?", "Delete Dealer Location " + dealer.name).result.then(function () {
			$ctrl.bus.send('DeleteDealerLocation.json', dealer).then(function (response) {
				$ctrl.$emit('dealerDeleted', $ctrl);
				$ctrl.load();
			});
		});
	}
}

export default {
	bindings: {},
	controller: DealerListController,
	templateUrl($element, $attrs) {
		return $attrs.templateUrl || templateUrl;
	}
};
